import React, {useEffect, useState} from "react";


import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {InputNumber} from "primereact/inputnumber";
import {generateRandomString} from "../../utilities/randomGenerator";
import {Dropdown} from "primereact/dropdown";
import {FloatLabel} from "primereact/floatlabel";


function MfxInputPanel({mfxList, itemList, saveMfx, selectedDate}) {
    const [mfxLists, setMfxLists] = useState([])

    useEffect(() => {
        setMfxLists(mfxList)
    }, [mfxList])

    const addTemplate = (rowData) => {
        const icon = 'pi pi-plus'
        const addNewLine = () => {
            const newData = {
                id: generateRandomString(4),
                date: selectedDate,
                status: "INPT",
                itemId: 0,
                itemName: "",
                quantity: 0,

            };
            let x = [...mfxLists, newData]
            setMfxLists(x);
            console.log(mfxLists)
        }
        return <Button type="button" icon={icon} className="p-button-sm p-button-text"
                       disabled={rowData.itemName === ""}
                       onClick={() => addNewLine()}/>;
    }
    const dropEditor = (options) => {
        return (
            <FloatLabel>
                <Dropdown id="dropdown"
                          style={{width: '200px'}}
                          className="flex h-2rem align-items-center"
                          value={options.value}
                          options={itemList.map(item => {
                              return item.name
                          })}
                          onChange={(e) => {
                              options.editorCallback(e.value)
                          }}

                />
                <label htmlFor="dropdown">Input Items</label>
            </FloatLabel>
        );
    }
    const numberEditor = (options, currentIndex) => {
        const disable = (options.rowData.itemName === "")

        return (
            <FloatLabel>
            <InputNumber inputStyle={{fontSize: '8px'}} value={options.value} className="h-2rem" id="qIn"
                         disabled={disable}
                         onChange={(e) => {
                             options.editorCallback(e.value)
                         }}
            ></InputNumber>
                <label htmlFor="qIn">Quantity</label>

            </FloatLabel>
    )
    }
    const deleteTemplate = (rowData, options) => {
        const icon = 'pi pi-trash'
        const deleteRow = (rowData) => {
            let _data = mfxLists.filter(item => item.id !== rowData.id);
            if (_data.length > 0) {

                setMfxLists(_data);
            } else {

                const newData = {
                    id: generateRandomString(4),
                    date: selectedDate,
                    status: "INPT",
                    itemId: 0,
                    itemName: "",
                    quantity: 0,

                };
                setMfxLists([newData]);
            }
        };
        return <Button type="button" icon={icon} className="p-button-sm p-button-text"
                       disabled={rowData.posted}
                       onClick={() => deleteRow(rowData)}/>;
    };
    const onCellEditComplete = (e) => {
        let _products = [...mfxLists];
        let {newData, field, newValue} = e;

        // Update the specific field in the row
        _products[e.rowIndex][field] = newValue;
        if (e.value !== newValue && e.rowData.customerName !== "" && e.rowData.department !== "") {
            setMfxLists(_products);
        }
    };
    return (
        <>
            <div className="container   w-full md:w-fit border-2 border-gray-300 rounded-md p-2 ">
                <DataTable value={mfxLists} resizableColumns className="p-datatable-striped p-datatable-gridlines"
                           size={"small"} style={{fontSize: '9px'}}
                           editMode="cell"
                           tableStyle={{minWidth: '28rem'}} stripedRows showGridlines={true} scrollable
                           scrollHeight="400px">
                    <Column field="+" header="Add" body={addTemplate} className="w-1"
                            headerStyle={{backgroundColor: '#fff0f0'}}></Column>
                    <Column field="itemName" header="Item" editor={dropEditor} className="w-6" alignHeader="left"
                            onCellEditComplete={onCellEditComplete} headerStyle={{backgroundColor: '#fff0f0'}}></Column>
                    <Column field="quantity" header="Quantity" className="w-4" alignHeader="left" editor={numberEditor}
                            headerStyle={{backgroundColor: '#fff0f0'}}
                            onCellEditComplete={onCellEditComplete}></Column>
                    <Column field="remove" header="Remove" body={deleteTemplate} className="w-1"
                            headerStyle={{backgroundColor: '#fff0f0'}}></Column>

                </DataTable>
            </div>
            < div className=" container-fluid w-fit mt-2">
                <Button label="Save" icon="pi pi-save" className="p-button-raised p-button-success"
                        onClick={() => saveMfx(mfxLists)}/>
            </div>
        </>
    )
}

export default MfxInputPanel;
